import React from 'react';
import { Link } from 'react-router-dom';
import service1 from '../../assets/images/service1.png'
import service2 from '../../assets/images/service2.png'
import service3 from '../../assets/images/service3.png'

const servicesData = [
    {
        icon: 'icofont-tasks-alt',
        title: 'Expunere pentru afacerea ta',
        subtitle: 'E timpul ca serviciile tale să fie descoperite',
        description: 'Dacă oferi orice serviciu care funcționează pe bază de programare – de la beauty și wellness, la servicii tehnice, consultanță sau coaching - LUMO este locul potrivit pentru tine.. Chiar dacă serviciul tău nu e unul „clasic”, e foarte posibil să fie exact ce caută cineva.',
        features: [
            '🔹 Te promovăm acolo unde contează',
            '🔹 Totul într-o interfață intuitivă',
            '🔹 Comunicare directă, fără intermedieri',
            '🔹 Plus beneficii speciale pentru furnizorii activi'
        ],
        imageSrc: service1,
        ctaText: 'Afla mai multe'
    },
    {
        icon: 'icofont-ui-clock',
        title: 'Sistem unic de loialitate',
        subtitle: 'LUMO Rewards loialitatea ta merită mai mult',
        description: 'LUMO Rewards este sistemul nostru prin care fiecare rezervare realizată în aplicație se transformă în puncte de loialitate. Acestea pot fi apoi folosite pentru a obține vouchere sau premii oferite de partenerii noștri – simplu, automat și fără taxe ascunse.Este modul nostru de a spune „mulțumim” celor care aleg să revină.',
        features: [
            "🔹 Puncte acumulate la fiecare rezervare",
            "🔹 Recompense reale – de la vouchere eMAG la alte beneficii digitale",
            "🔹 Gestionare 100% automată, fără efort din partea ta",
            "🔹 Fără taxe ascunse, fără bătăi de cap"
        ],
        imageSrc: service2,
        ctaText: 'Începe să caștigi'
    }
];

function Service() {
    return (
        <section className="row_am service_section">
            <div className="container">
                <div className="section_title" data-aos="fade-up" data-aos-duration={1500}>
                    <span className="title_badge mb-1">Platformă pentru toți</span>
                    <h2>
                        LUMO înseamnă mai mult <br/>decât o simplă <span>programare</span>
                    </h2>
                </div>
                {servicesData.map((service, index) => (
                    <div className={`row service_blocks ${index % 2 === 0 ? '' : 'flex-row-reverse'}`} key={index}>
                        <div className="col-md-6">
                            <div className={`service_text ${index % 2 === 0 ? '' : 'right_side'}`} data-aos="fade-up" data-aos-duration={1500}>
                                {/* 
                                <div className="service_badge">
                                    <i className={service.icon} />
                                    <span>{service.title}</span>
                                </div>
                                */}
                                <h2>
                                    <span>{service.subtitle}</span>
                                </h2>
                                <p>
                                    {service.description}
                                </p>
                                <ul className={`${index % 2 === 0 ? 'listing_block' : 'feature_list'}`}>
                                    {service.features.map((feature, featureIndex) => (
                                        <li key={featureIndex}>
                                            <div className="text">
                                                <h6>{feature}</h6>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                                <div className="btn_block">
                                    <Link to="/contact" className="btn puprple_btn color-lumo-orange ml-0">
                                        {service.ctaText}
                                    </Link>
                                    <div className="btn_bottom border-color-lumo-orange" />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="img" data-aos="fade-up" data-aos-duration={1500}>
                                <img src={service.imageSrc} alt="image" />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default Service;
